module.exports = __webpack_public_path__ + "img/dm_logo.4631cf30.png";